module.exports = __webpack_public_path__ + "img/money.cdc9b4a8.jpg";